export default `
query getProductAdditionalData($sku:String!) {
  products(filter: {sku: {eq: $sku}}, search: " ") {
    items {
      sku
      ean
      delivery_time
      schreibgeraet_typ
      product_top_category
			manufacturer_main_category
			category_type_main_txt
			category_type_manufacturer_txt

      categories {
        uid
        name
      }
      druckerpatronen_hersteller
      custom_attributes {
        attribute_metadata {
          code
          data_type
          entity_type
          is_system
          label
          sort_order
          uid

          ... on ProductAttributeMetadata {
            used_in_components
          }
        }
        selected_attribute_options {
          attribute_option {
            label
          }
        }
      }
    }
  }
}`;
